/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowVirtualRealityExperienceTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowVirtualRealityExperience,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Dive into VR!",
    "Virtual Reality Awaits!",
    "Experience a New Dimension!",
  ],
  title: "Virtual Reality Experience",
  description: "Organize an exciting virtual reality experience.",
  longDescription:
    "Gather your friends for a thrilling virtual reality experience! Choose a date, decide on games or experiences to try, and plan snacks for afterward!",
  emoji: "🕶",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Virtual Reality Experience",
          emoji: "🕶",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the virtual reality experience?",
          emoji: "📅",
          completeAction: {
            question: "Decide on VR experiences to try?",
            description: "What VR experiences should we explore?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What VR experiences should we choose?",
                emoji: "🎮",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we enjoy during the VR experience?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Experience the Future!",
    outroDescription:
      "Your virtual reality plans are set! Enjoy the adventure!",
  },
};
